import React, { useEffect, useState } from 'react'
import { flushSync } from 'react-dom';
import { PropTypes } from 'prop-types';
import { CustomTabsV2 } from '../../../components/StyledComponents';
import { Tab } from '@mui/material';
import GeneralTab from './GeneralTab';
import ClientTab from './ClientTab';
import { getListEntitie } from '../../../axios/Setting/SettingUrlApi';
import { useLoading } from '../../../context/LoadingContext';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`settings-${index}`}
            aria-labelledby={`settings-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div className='mt-3'>
                    {children}
                </div>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
    return {
        id: `settings-tab-${index}`,
        'aria-controls': `settings-tabpanel-${index}`,
    };
}

const SettingsTabs = (props) => {
    const { tabValue, setTabValue, setLoading } = props
    const [show, hide] = useLoading();
    const [generalTabId, setGeneralTabId] = useState(null)
    const [clientTabId, setClientTabId] = useState(null)
    const [biometricTabId, setBiometricTabId] = useState(null);
    const [webTabId, setWebTabId] = useState(null);
    const [departmentTabId, setDepartmentTabId] = useState(null);
    const [notificationTabId, setNotificationTabId] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const { t } = useTranslation();

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleRefresh = () => {
        setRefresh((prev) => !prev);
    };

    // Tour: chuyển tab General / Client
    useEffect(() => {
        window.__setSettingsMainTab = (index) => {
            flushSync(() => setTabValue(index));
        };
        return () => {
            delete window.__setSettingsMainTab;
        };
    }, [setTabValue]);

    useEffect(() => {
        const fetchData = async () => {
            show();
            try {
                const { data } = await getListEntitie(localStorage.getItem("i18nextLngId"));
                const settings = data.data;

                const map = Object.fromEntries(
                    settings.map(item => [item.settingTypeName, item.settingTypeId])
                );

                if (map.GENERAL) setGeneralTabId(map.GENERAL);
                if (map.CLIENTS) setClientTabId(map.CLIENTS);
                if (map.BIOMETRIC) setBiometricTabId(map.BIOMETRIC);
                if (map.WEB) setWebTabId(map.WEB);
                if (map.DEPARTMENTS) setDepartmentTabId(map.DEPARTMENTS);
                if (map.NOTIFICATIONS) setNotificationTabId(map.NOTIFICATIONS)
            } catch (error) {
                if (error.response) {
                    if (error.response.status !== 401) {
                        toast.error(t(error?.response.data));
                    }
                } else {
                    toast.error(t('common.network-timeout'));
                }
            } finally {
                hide();
            }
        };

        fetchData();
    }, []);


    return (
        <div className='settings-tab'>
            <CustomTabsV2
                variant="fullWidth"
                indicatorColor='none'
                value={tabValue}
                onChange={handleChangeTab}>
                <Tab
                    label={t('common.general')}
                    {...a11yProps(0)}
                    disableRipple
                    data-tour="setting-general"
                />
                <Tab
                    label={t('common.client')}
                    {...a11yProps(1)}
                    disableRipple
                    data-tour="setting-client"
                />
                {/* <Tab label={t('common.notifications')} {...a11yProps(2)} disableRipple />
                <Tab label={t('common.departments')} {...a11yProps(3)} disableRipple /> */}
                {/* <Tab label={t('button.biometric')} {...a11yProps(4)} disableRipple disabled/>
                <Tab label="Web" {...a11yProps(5)} disableRipple disabled/>
                <Tab label={t('common.licenses')} {...a11yProps(6)} disableRipple disabled />
                <Tab label={t('common.miscellaneous')} {...a11yProps(7)} disableRipple disabled /> */}
            </CustomTabsV2>
            <CustomTabPanel value={tabValue} index={0}>
                <div className='px-4 py-2'>
                    <GeneralTab departmentTabId={departmentTabId} tabId={generalTabId} tabNotiId={notificationTabId} tabWebId={webTabId} tabDepartmentId={departmentTabId} refreshData={refresh} handleRefresh={handleRefresh} />
                </div>
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={1}>
                <div className='px-4 py-2'>
                    <ClientTab tabId={clientTabId} refreshData={refresh} handleRefresh={handleRefresh} />
                </div>
            </CustomTabPanel>
        </div>
    )
}

export default SettingsTabs